const swiperArticles = new Swiper(".swiper--articles", {
  slidesPerView: 1.1,
  spaceBetween: 12,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    990: {
      slidesPerView: 3,
      spaceBetween: 24
    },
    750: {
      slidesPerView: 2.1,
      spaceBetween: 24
    }
  }
});